var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.501 20.2499H11.501C11.091 20.2499 10.751 19.9099 10.751 19.4999C10.751 19.0899 11.091 18.7499 11.501 18.7499H21.501C21.911 18.7499 22.251 19.0899 22.251 19.4999C22.251 19.9099 21.911 20.2499 21.501 20.2499Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.501 13.2499H11.501C11.091 13.2499 10.751 12.9099 10.751 12.4999C10.751 12.0899 11.091 11.7499 11.501 11.7499H21.501C21.911 11.7499 22.251 12.0899 22.251 12.4999C22.251 12.9099 21.911 13.2499 21.501 13.2499Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.501 6.24994H11.501C11.091 6.24994 10.751 5.90994 10.751 5.49994C10.751 5.08994 11.091 4.74994 11.501 4.74994H21.501C21.911 4.74994 22.251 5.08994 22.251 5.49994C22.251 5.90994 21.911 6.24994 21.501 6.24994Z",
    fill: "#26B5ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50141 7.24994C4.31141 7.24994 4.12141 7.17994 3.97141 7.02994L2.97141 6.02994C2.68141 5.73994 2.68141 5.25994 2.97141 4.96994C3.26141 4.67994 3.74141 4.67994 4.03141 4.96994L4.50141 5.43994L6.97141 2.96994C7.26141 2.67994 7.74141 2.67994 8.03141 2.96994C8.32141 3.25994 8.32141 3.73994 8.03141 4.02994L5.03141 7.02994C4.88141 7.17994 4.69141 7.24994 4.50141 7.24994Z",
    fill: "#26B5ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50141 14.2499C4.31141 14.2499 4.12141 14.1799 3.97141 14.0299L2.97141 13.0299C2.68141 12.7399 2.68141 12.2599 2.97141 11.9699C3.26141 11.6799 3.74141 11.6799 4.03141 11.9699L4.50141 12.4399L6.97141 9.96994C7.26141 9.67994 7.74141 9.67994 8.03141 9.96994C8.32141 10.2599 8.32141 10.7399 8.03141 11.0299L5.03141 14.0299C4.88141 14.1799 4.69141 14.2499 4.50141 14.2499Z",
    fill: "#26B5ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50141 21.2499C4.31141 21.2499 4.12141 21.1799 3.97141 21.0299L2.97141 20.0299C2.68141 19.7399 2.68141 19.2599 2.97141 18.9699C3.26141 18.6799 3.74141 18.6799 4.03141 18.9699L4.50141 19.4399L6.97141 16.9699C7.26141 16.6799 7.74141 16.6799 8.03141 16.9699C8.32141 17.2599 8.32141 17.7399 8.03141 18.0299L5.03141 21.0299C4.88141 21.1799 4.69141 21.2499 4.50141 21.2499Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.3df6f9551de9e33855b2fc8a7a65e27f.svg";
export { ForwardRef as ReactComponent };